import React, {useContext} from 'react';
import EnvironmentVariablesContext
  from './contexts/EnvironmentVariablesContext';
import {createGlobalStyle, ThemeProvider} from "styled-components";
import tokens from './theme/tokens';
import useDeviceInfo from "./hooks/useDeviceInfo";

export default function AppThemeProvider ({
  children
}) {
  const environmentVariables = useContext(EnvironmentVariablesContext);

  const deviceInfo = useDeviceInfo();

  const theme = {
    tokens: {
      ...tokens,
      typography: {
        fontFamily: {
          title: environmentVariables.REACT_APP_PROJECT_TITLES_FONT,
          body: environmentVariables.REACT_APP_PROJECT_BODY_FONT,
        }
      },
      color: {
        backgroundColor: environmentVariables.REACT_APP_PROJECT_BACKGROUND_COLOR,
        interfacePrimaryColor: environmentVariables.REACT_APP_PROJECT_INTERFACE_PRIMARY_COLOR,
        interfaceSecondaryColor: environmentVariables.REACT_APP_PROJECT_INTERFACE_SECONDARY_COLOR,
        controlsPrimaryColor: environmentVariables.REACT_APP_PROJECT_CONTROLS_PRIMARY_COLOR,
        controlsSecondaryColor: environmentVariables.REACT_APP_PROJECT_CONTROLS_SECONDARY_COLOR,
      }
    },
    deviceInfo
  };

  const TypographyGlobalStyle = createGlobalStyle`
    html, body {
      font-family: ${props => props.theme.tokens.typography.fontFamily.body};
    }
  `;
  const BackgroundGlobalStyle = createGlobalStyle`
    html, body {
      background: ${props => props.theme.tokens.color.backgroundColor};
    }
  `;

  return (
      <ThemeProvider theme={theme}>
        <BackgroundGlobalStyle />
        <TypographyGlobalStyle />
        {children}
      </ThemeProvider>
  );

}
